import { render, staticRenderFns } from "./navigation_drawer.vue?vue&type=template&id=664645c1&scoped=true"
import script from "./navigation_drawer.vue?vue&type=script&lang=js"
export * from "./navigation_drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664645c1",
  null
  
)

export default component.exports